import gql from 'graphql-tag'

export const updateBonus = ({ bonusId, bonusData, bonusRoles }) => {
	return {
		mutation: gql`
			mutation updateSingleContact(
				$bonus_id: bigint!
				$object: bonuses_set_input!
				$roles: [bonuses_roles_insert_input!]!
			) {
				update_bonuses_by_pk(pk_columns: { id: $bonus_id }, _set: $object) {
					id
				}
				delete_bonuses_roles(where: { bonus_id: { _eq: $bonus_id } }) {
					affected_rows
				}
				insert_bonuses_roles(objects: $roles) {
					affected_rows
				}
			}
		`,
		variables: {
			object: bonusData,
			bonus_id: bonusId,
			roles: bonusRoles.map(rol => ({
				bonus_id: bonusId,
				rol_id: rol.id
			}))
		}
	}
}
